"use strict"

export default function routes($stateProvider) {
  "ngInject"

  $stateProvider
    .state("mainmap.markers", {
      url: "/markers/:markers",
    })
    .state("mainmap.markers.detail", {
      url: "/:name",
    })
    .state("surroundings.markers", {
      url: "/markers/:markers",
    })
    .state("surroundings.markers.detail", {
      url: "/:name",
    })
}
